import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, GraduationCap, ArrowUpRight } from "lucide-react";
import api from "../lib/api";

export default function Workshops() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/workshops").then((r) => setItems(r.data));
  }, []);

  return (
    <div data-testid="workshops-page" className="bg-[#2A2A2A] min-h-screen">
      <header className="bg-[#1F1F1F] border-b border-[#3a3a3a] py-20">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="kicker mb-5">Oferta / Warsztaty</div>
          <h1 className="font-display text-white text-5xl md:text-7xl lg:text-[6rem] uppercase leading-[0.9]">
            Warsztaty<br/><span className="text-[#FFCC00]" data-testid="workshops-count">— {items.length}</span>
            <span className="text-white"> propozycji</span>
          </h1>
          <p className="mt-6 max-w-2xl text-white/65 text-lg">
            ...na kreatywnie spędzony czas. Praktyczne zajęcia z najlepszymi prowadzącymi w regionie.
            Wybierz dziedzinę, zarezerwuj termin i twórz w naszej pracowni w Katowicach.
          </p>
        </div>
      </header>

      <section className="py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((w, i) => (
            <Link
              key={w.id}
              to={`/warsztaty/${w.id}`}
              data-testid={`workshop-tile-${i}`}
              className="tile group bg-[#1F1F1F] border border-[#3a3a3a] flex flex-col"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img src={w.image_url} alt={w.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-5 border-t border-[#3a3a3a] flex flex-col flex-1">
                <div className="font-mono-acc text-[10px] text-[#FFCC00] uppercase mb-3">
                  #{String(i + 1).padStart(2, "0")} / {w.level || "Wszystkie poziomy"}
                </div>
                <h3 className="font-display text-white text-lg uppercase leading-snug flex-1">
                  {w.title}
                </h3>
                <div className="mt-4 flex items-center justify-between text-xs text-white/55 font-mono-acc">
                  <span className="inline-flex items-center gap-1.5"><Clock size={12}/> {w.duration || "4h"}</span>
                  <span className="inline-flex items-center gap-1.5 text-[#FFCC00]">
                    Szczegóły <ArrowUpRight size={14}/>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
